import {http, param} from '../../utils/http'
import conf from '../../config'
import fileDownload from 'js-file-download'
export const API_ROOT = `${conf.API_URL}`

const orgServices = {
    getSSOFilters() {
        return http.get(`${API_ROOT}/notisphere/organizations/filters-meta/sso`).then(resp => {
            return resp
        })
    },
    getStatusFilters() {
        return http.get(`${API_ROOT}/notisphere/organizations/filters-meta/status`).then(resp => {
            return resp
        })
    },
    getNotisphereManagedFilters() {
        return http.get(`${API_ROOT}/notisphere/organizations/filters-meta/notisphere-managed`).then(resp => {
            return resp
        })
    },
    findMeta(orgType = null) {
        return http.get(`${API_ROOT}/notisphere/organizations/meta${orgType == null ? '' : '?orgType=' + orgType}`).then(resp => {
            return resp
        })
    },
    findCreatorMeta() {
        return http.get(`${API_ROOT}/notisphere/organizations/recall-Orgmeta`).then(resp => {
            return resp
        })
    },
    findKPIMeta(organization_id) {
        return http.get(`${API_ROOT}/notisphere/organizations/kpi-meta/${organization_id == null ? 0 : organization_id}`).then(resp => {
            return resp
        })
    },
    //supplier
    findSuppliers(payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search ? payload.search.trim() : '' },
            { query: 'name', val: payload.name ? payload.name.trim() : '' },
            { query: 'add1', val: payload.add1 ? payload.add1.trim() : '' },
            { query: 'add2', val: payload.add2 ? payload.add2.trim() : '' },
            { query: 'city', val: payload.city ? payload.city.trim() : '' },
            { query: 'state', val: payload.state ? payload.state.trim() : '' },
            { query: 'zip', val: payload.zip ? payload.zip.trim() : '' },
            { query: 'filterModel', val: payload.filterModel ?  encodeURIComponent(JSON.stringify(payload.filterModel))  : null }
        ]
        return http.get(`${API_ROOT}/notisphere/organizations/suppliers${param(arr)}`).then(resp => {
            return resp
        })
    },
    downloadAgGridSupplierAccountXLSXRecall (payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search ? payload.search.trim() : '' },
            { query: 'name', val: payload.name ? payload.name.trim() : '' },
            { query: 'add1', val: payload.add1 ? payload.add1.trim() : '' },
            { query: 'add2', val: payload.add2 ? payload.add2.trim() : '' },
            { query: 'city', val: payload.city ? payload.city.trim() : '' },
            { query: 'state', val: payload.state ? payload.state.trim() : '' },
            { query: 'zip', val: payload.zip ? payload.zip.trim() : '' },
            { query: 'email', val: payload.email ? encodeURIComponent(payload.email) : null},
            { query: 'filterModel', val: payload.filterModel ?  encodeURIComponent(JSON.stringify(payload.filterModel))  : null }
        ]
        return http.get(`${API_ROOT}/notisphere/organizations/downloadAgGridSupplierAccountxlsx${param(arr)}`).then(resp => {
            return resp
        })
    },
    //supplier list
    async createSupplierName(payload) {
        const formData = new FormData()
        formData.append('CreatedBy', payload.createdBy)
        formData.append('Name', payload.name)
        formData.append('Id', payload.id ?? '')
        if (payload.logo) {
            formData.append('Logo', payload.logo)
        }
        return http.post(`${API_ROOT}/notisphere/organizations/create-suppliers`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async ProcessSupplierFile(formData) {
        return http.post(`${API_ROOT}/notisphere/organizations/process-supplier-logo-file`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    GetSupplierNameList () {
        return http.get(`${API_ROOT}/notisphere/organizations/supplierNameList`).then(resp => {
            return resp
        })
    },
    GetOrganizationListByType (type) {
        return http.get(`${API_ROOT}/notisphere/organizations/list/${type}`).then(resp => {
            return resp
        })
    },
    GetKnownSupplierProfile (id) {
        return http.get(`${API_ROOT}/notisphere/organizations/knownsuppliers/${id}`).then(resp => {
            return resp
        })
    },
    GetKnownSupplierProfileForRecall (id) {
        return http.get(`${API_ROOT}/notisphere/organizations/knownsuppliers/logo/${id}`).then(resp => {
            return resp
        })
    },
    async linkSupplierName(id,linkedSupplierId) {

        return http.put(`${API_ROOT}/notisphere/organizations/link-suppliers/${id}/${linkedSupplierId}`).then(resp => {
            return resp
        })
    },
    async findSuppliersList(payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search ? payload.search.trim() : '' },
            { query: 'filterModel', val: payload.filterModel ?  encodeURIComponent(JSON.stringify(payload.filterModel))  : null },
        ]
        return http.get(`${API_ROOT}/notisphere/organizations/suppliers-list${param(arr)}`).then(resp => {
            return resp
        })
    },
    async updateSupplierList(id,status) {
        var arr = [
            { query: 'id', val: id },
            { query: 'status', val: status },
        ]
        return http.get(`${API_ROOT}/notisphere/organizations/update-suppliers-list${param(arr)}`).then(resp => {
            return resp
        })
    },
    downloadAgGridSupplierListXLSX(payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search ? payload.search.trim() : '' },
            { query: 'email', val: payload.email ? encodeURIComponent(payload.email) : null },
            { query: 'filterModel', val: payload.filterModel ? encodeURIComponent(JSON.stringify(payload.filterModel)) : null }
        ]
        return http.get(`${API_ROOT}/notisphere/organizations/downloadAgGridSupplierListxlsx${param(arr)}`).then(resp => {
            return resp
        })
    },
    getSupplier(organization_id) {
        return http.get(`${API_ROOT}/notisphere/organizations/suppliers/${organization_id}`).then(resp => {
            return resp
        })
    },
    updateSupplier(payload) {
        return http.put(`${API_ROOT}/notisphere/organizations/suppliers/${payload.id}`, payload).then(resp => {
            return resp
        })
    },
    createSupplier(payload) {
        return http.post(`${API_ROOT}/notisphere/organizations/suppliers`, payload).then(resp => {
            return resp
        })
    },
    deletePendingSupplier(organization_id) {
        return http.delete(`${API_ROOT}/notisphere/organizations/suppliers/${organization_id}`).then(resp => {
            return resp
        })
    },
    //provider
    findProviders(payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search ? payload.search.trim() : '' },
            { query: 'name', val: payload.name ? payload.name.trim() : '' },
            { query: 'add1', val: payload.add1 ? payload.add1.trim() : '' },
            { query: 'add2', val: payload.add2 ? payload.add2.trim() : '' },
            { query: 'city', val: payload.city ? payload.city.trim() : '' },
            { query: 'state', val: payload.state ? payload.state.trim() : '' },
            { query: 'zip', val: payload.zip ? payload.zip.trim() : '' },
            { query: 'notisphere_id', val: payload.notisphere_id ? payload.notisphere_id.trim() : '' },
            { query: 'sites', val: payload.sites ? payload.sites.trim() : null},
            { query: 'number_of_hospitals', val: payload.number_of_hospitals ? payload.number_of_hospitals.trim() : null},
            { query: 'number_of_non_acute_sites', val: payload.number_of_non_acute_sites ? payload.number_of_non_acute_sites.trim() : null},
            { query: 'filterModel', val: payload.filterModel ?  encodeURIComponent(JSON.stringify(payload.filterModel))  : null }
        ]
        return http.get(`${API_ROOT}/notisphere/organizations/providers${param(arr)}`).then(resp => {
            return resp
        })
    },
    getProvider(organization_id) {
        return http.get(`${API_ROOT}/notisphere/organizations/providers/${organization_id}`).then(resp => {
            return resp
        })
    },
    updateProvider(payload) {
        return http.put(`${API_ROOT}/notisphere/organizations/providers/${payload.id}`, payload).then(resp => {
            return resp
        })
    },
    createProvider(payload) {
        return http.post(`${API_ROOT}/notisphere/organizations/providers`, payload).then(resp => {
            return resp
        })
    },
    deletePendingProvider(organization_id) {
        return http.delete(`${API_ROOT}/notisphere/organizations/providers/${organization_id}`).then(resp => {
            return resp
        })
    },
    getProviderOrgMetaData () {
        return http.get(`${API_ROOT}/notisphere/organizations/providerorgmeta`).then(resp => {
            return resp
        })
    },
    getProviderOrgDocData (payload) {
        return http.get(`${API_ROOT}/notisphere/organizations/providerdocdata/${payload.id}`).then(resp => {
            return resp
        })
    },
    downloadProviderAccountCSVRecall (payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search ? payload.search.trim() : '' },
            { query: 'name', val: payload.name ? payload.name.trim() : '' },
            { query: 'add1', val: payload.add1 ? payload.add1.trim() : '' },
            { query: 'add2', val: payload.add2 ? payload.add2.trim() : '' },
            { query: 'city', val: payload.city ? payload.city.trim() : '' },
            { query: 'state', val: payload.state ? payload.state.trim() : '' },
            { query: 'zip', val: payload.zip ? payload.zip.trim() : '' },
            { query: 'notisphere_id', val: payload.notisphere_id ? payload.notisphere_id.trim() : '' },
            { query: 'sites', val: payload.sites ? payload.sites.trim() : null},
            { query: 'number_of_hospitals', val: payload.number_of_hospitals ? payload.number_of_hospitals.trim() : null},
            { query: 'number_of_non_acute_sites', val: payload.number_of_non_acute_sites ? payload.number_of_non_acute_sites.trim() : null},
            { query: 'filterModel', val: payload.filterModel ?  encodeURIComponent(JSON.stringify(payload.filterModel))  : null }
        ]
        return http.get(`${API_ROOT}/notisphere/organizations/downloadprovideraccountcsv${param(arr)}`,{ responseType: 'blob' }).then(resp => {
            var date = new Date()
            var DateTime = (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)))  + '-' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) +'-'+ date.getFullYear())
            fileDownload(resp.data, 'Provider Account Report ' + DateTime +'.csv','text/csv')
        })
    },
    downloadAgGridProviderAccountXLSXRecall (payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search ? payload.search.trim() : '' },
            { query: 'name', val: payload.name ? payload.name.trim() : '' },
            { query: 'add1', val: payload.add1 ? payload.add1.trim() : '' },
            { query: 'add2', val: payload.add2 ? payload.add2.trim() : '' },
            { query: 'city', val: payload.city ? payload.city.trim() : '' },
            { query: 'state', val: payload.state ? payload.state.trim() : '' },
            { query: 'zip', val: payload.zip ? payload.zip.trim() : '' },
            { query: 'notisphere_id', val: payload.notisphere_id ? payload.notisphere_id.trim() : '' },
            { query: 'sites', val: payload.sites ? payload.sites.trim() : null},
            { query: 'number_of_hospitals', val: payload.number_of_hospitals ? payload.number_of_hospitals.trim() : null},
            { query: 'number_of_non_acute_sites', val: payload.number_of_non_acute_sites ? payload.number_of_non_acute_sites.trim() : null},
            { query: 'filterModel', val: payload.filterModel ?  encodeURIComponent(JSON.stringify(payload.filterModel))  : null },
            { query: 'email', val: payload.email ? encodeURIComponent(payload.email) : null},
        ]
        return http.get(`${API_ROOT}/notisphere/organizations/downloadAgGridProviderAccountxlsx${param(arr)}`).then(resp => {
            return resp
        })
    },
    downloadProviderAccountXLSXRecall (payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search ? payload.search.trim() : '' },
            { query: 'name', val: payload.name ? payload.name.trim() : '' },
            { query: 'add1', val: payload.add1 ? payload.add1.trim() : '' },
            { query: 'add2', val: payload.add2 ? payload.add2.trim() : '' },
            { query: 'city', val: payload.city ? payload.city.trim() : '' },
            { query: 'state', val: payload.state ? payload.state.trim() : '' },
            { query: 'zip', val: payload.zip ? payload.zip.trim() : '' },
            { query: 'notisphere_id', val: payload.notisphere_id ? payload.notisphere_id.trim() : '' },
            { query: 'sites', val: payload.sites ? payload.sites.trim() : null},
            { query: 'number_of_hospitals', val: payload.number_of_hospitals ? payload.number_of_hospitals.trim() : null},
            { query: 'number_of_non_acute_sites', val: payload.number_of_non_acute_sites ? payload.number_of_non_acute_sites.trim() : null},
            { query: 'filterModel', val: payload.filterModel ?  encodeURIComponent(JSON.stringify(payload.filterModel))  : null }
        ]
        return http.get(`${API_ROOT}/notisphere/organizations/downloadprovideraccountxlsx${param(arr)}`,{ responseType: 'blob' }).then(resp => {
            var date = new Date()
            var DateTime = (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)))  + '-' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) +'-'+ date.getFullYear())
            fileDownload(resp.data, 'Provider Account Report ' + DateTime +'.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        })
    },
    downloadDetailedProviderActivityReport() {
        return http.get(`${API_ROOT}/notisphere/organizations/downloaddetailprovideractivityxlsx`,{ responseType: 'blob' }).then(resp => {
            var date = new Date()
            var DateTime = (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)))  + '-' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) +'-'+ date.getFullYear())
            fileDownload(resp.data, 'Detailed Activity Report ' + DateTime +'.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        })
    },
    downloadProviderActivityReport() {
        return http.get(`${API_ROOT}/notisphere/organizations/downloadprovideractivityxlsx`,{ responseType: 'blob' }).then(resp => {
            var date = new Date()
            var DateTime = (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)))  + '-' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) +'-'+ date.getFullYear())
            fileDownload(resp.data, 'Provider Activity Report ' + DateTime +'.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        })
    },
    downloadConsolidatedProviderReport(){
        return http.get(`${API_ROOT}/notisphere/organizations/downloadconsolidatedproviderxlsx`,{ responseType: 'blob' }).then(resp => { var date = new Date()
            var DateTime = (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)))  + '-' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) +'-'+ date.getFullYear())
            fileDownload(resp.data, 'Consolidated Provider Report ' + DateTime +'.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        })
    },
    addProviderContactInfoStep0(payload) {
        return http.post(`${API_ROOT}/notisphere/organizations/contact-info/step0`, payload).then(resp => {
            return resp
        })
    },
    getContactInfoEmailTemplate(type) {
        return http.get(`${API_ROOT}/notisphere/organizations/contact-info/emailTemplate/${type}`).then(resp => {
            return resp
        })
    },
    sendEmailVerification(payload) {
        return http.post(`${API_ROOT}/notisphere/organizations/contact-info/verification`, payload).then(resp => {
            return resp
        })
    },
    getContactInfoVerifiedEmails(organizationId) {
        return http.get(`${API_ROOT}/notisphere/organizations/contact-info/verifiedMailList/${organizationId}`).then(resp => {
            return resp
        })
    },
    getNonVerifiedUsers(payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search ? payload.search.trim() : '' },
            { query: 'organizationId', val: payload.organizationId },
            { query: 'filterModel', val: encodeURIComponent(JSON.stringify({})) }
        ]
        return http.get(`${API_ROOT}/notisphere/organizations/contact-info/getNonVerifiedUsers${param(arr)}`).then(resp => {
            return resp
        })
    },
    createNonVerifiedUser(payload) {
        return http.post(`${API_ROOT}/notisphere/organizations/contact-info/nonVerifiedUser`, payload).then(resp => {
            return resp
        })
    },
    getRoleMeta(organization_id,isNonVerifiedChecked) {
        return http.get(`${API_ROOT}/notisphere/organizations/role-meta?organization_id=${organization_id ? organization_id : ''}&isNonVerifiedChecked=${isNonVerifiedChecked}`).then(resp => {
            return resp
        })
    },
    getNonVerifiedUserMailList(organizationId) {
        return http.get(`${API_ROOT}/notisphere/organizations/contact-info/getNonVerifiedUserMailList/${organizationId}`).then(resp => {
            return resp
        })
    }
}

export default orgServices
